import React from 'react';
import PortalRichTextField from './PortalRichTextField';
import { positionFieldDescriptions } from './registrationFieldDescriptions';
export default function PositionRequirements({ name, value = '', disabled }) {
  return (
    <PortalRichTextField
      name={name}
      label="Requisitos"
      value={value}
      disabled={disabled}
      help={positionFieldDescriptions.requirements}
      placeholder="Descreva os requisitos para concorrer."
    />
  );
}
